import { TUser } from '../../types/user';

const defaultState: TUser = {
  isAuthenticated: false,
};

export function userReducer(state: TUser = defaultState) {
  return state;
}
